import { createSelector } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { State } from './reducer';
import { selectHomeRegimesState } from '../selectors';

export const getData = createSelector(selectHomeRegimesState, (state: State) => state.data);

export const getError = createSelector(selectHomeRegimesState, (state: State) => state.error);

export const getLoading = createSelector(selectHomeRegimesState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: ParameterResult[]) => T) =>
  createSelector(selectHomeRegimesState, (state: State) => fn(state.data));
